import { Icon, IconProps } from "../";

export const TriangleBottomLineIcon = (props: IconProps) => {
  return (
    <Icon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 16L17.1962 7H6.80386L12 16ZM11.134 18.5C11.5189 19.1667 12.4811 19.1667 12.866 18.5L19.7942 6.5C20.1791 5.83333 19.698 5 18.9282 5H5.0718C4.302 5 3.82088 5.83333 4.20578 6.5L11.134 18.5Z"
      />
    </Icon>
  );
};
